import ModelTypeConstants from 'constants/ModelTypeConstants';
import getNotePartType from 'notebook/notes/util/getNotePartType';
import {TABLE} from 'notebook/tables/augmentNotePartTablesWithValues';
import {TABLE_OPS} from 'notebook/tables/augmentNotePartTablesWithValues';
import {NotePart, NotePartWithItem} from 'notebook/util/NoteUtilConstants';
import {NoteLinkedAssayData} from 'runs/AttachmentConstants';

export function getNumberOfStructuredTablesInNotePart(notePart: NotePart): number {
  const type = getNotePartType(notePart);
  if (
    type == null ||
    type === TABLE ||
    (!TABLE_OPS[type] && !(type === ModelTypeConstants.NOTE_LINKED_ASSAY_DATA))
  ) {
    return 0;
  }

  if (type === ModelTypeConstants.NOTE_LINKED_ASSAY_DATA) {
    const notePartWithItem = notePart as NotePartWithItem<NoteLinkedAssayData>;
    return (
      notePartWithItem.item.versionedData.structuredTables.length + notePartWithItem.item.dataTables.length
    );
  }
  return 1;
}
